import React from 'react';

export default function ErrorModal({ isOpen, onClose, title, message, variant = 'error' }) {
  if (!isOpen) return null;

  const isSuccess = variant === 'success';
  const color = isSuccess ? 'green' : 'red';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[2500] flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-[400px] shadow-xl">
        <div className="flex justify-between items-start mb-4">
          <h3 className={`text-lg font-semibold text-${color}-600`}>{title}</h3>
          <button
            onClick={onClose}
            className={`text-gray-400 hover:text-${color}-600 transition-colors`}
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className={`px-4 py-2 text-white bg-${color}-600 rounded hover:bg-${color}-700 transition-colors`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
